import type { VoidFunctionComponent } from 'react';

import { plural } from '../../../../../shared/helpers';
import {
  Icon,
  icons,
} from '../../../generic';
import type { Project } from '../../../../../shared/projectsV2';

type Props = {
  items: Project[];
  category: string;
};

const MAX_LIST_SIZE = 5;

const ProjectListComponent: VoidFunctionComponent<Props> = ({ items, category }) => {
  return (
    <div className="projects-dashboard-v2-modal__body__projects">
      {items.slice(0, MAX_LIST_SIZE).map((p) => (
        <div className="projects-dashboard-v2-modal__body__projects__item">
          <div className="projects-dashboard-v2-modal__body__projects__item__icon">
            <Icon icon={icons.folder} />
          </div>
          <span className="projects-dashboard-v2-modal__body__projects__item__title">{p.title}</span>
        </div>
      ))}
      {items.length > MAX_LIST_SIZE &&
        <div className="projects-dashboard-v2-modal__body__projects__more_projects">
          {`+${items.length - MAX_LIST_SIZE} ${plural(items.length - MAX_LIST_SIZE, category)}`}
        </div>}
    </div>
  );
};

export default ProjectListComponent;
